import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TanzaniaFlag from './TanzaniaFlag';
import UKflag from './UkFlag';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [language, setLanguage] = useState(i18n.language);

    useEffect(() => {
        const storedLanguage = localStorage.getItem('lang');
        if (storedLanguage && storedLanguage !== i18n.language) {
            i18n.changeLanguage(storedLanguage);
            setLanguage(storedLanguage);
        }
    }, [i18n]);

    const toggleLanguage = () => {
        const newLanguage = language === 'en' ? 'sw' : 'en';
        i18n.changeLanguage(newLanguage);
        setLanguage(newLanguage);
        localStorage.setItem('lang', newLanguage);
    };

    return (
        <button
            className="p-1.5 h-10 w-10 bg-transparent border border-gray-400 
                       hover:border-gray-500 cursor-pointer rounded-lg transition-all 
                       duration-200 hover:shadow-sm active:scale-95 
                       focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-[#41A6D7]"
            onClick={toggleLanguage}
            aria-label={`Switch to ${language === 'en' ? 'Swahili' : 'English'}`}
        >
            {language === 'en' ? <TanzaniaFlag /> : <UKflag />}
        </button>
    );
};

export default LanguageSwitcher;
